import { render, staticRenderFns } from "./TabPane.vue?vue&type=template&id=bc50c5d8&"
import script from "./TabPane.vue?vue&type=script&lang=js&"
export * from "./TabPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports